class ExternalDocumentData {

    constructor() {

        this._platforms = null;
        this._site = "";
        this._logo = "";
        this._title = "";
        this._description = "";
        this._card = "";
        this._html = "";
        this._url = "";
        this._duration = null;
        this._media = "";
        this._rel = [];
        this._thumbnail = "";

    }

    getThumbnail() {
        return this._thumbnail;
    }

    getRel() {
        return this._rel;
    }

    getMedia() {
        return this._media;
    }

    getDuration() {
        return this._duration;
    }

    getUrl() {
        return this._url;
    }

    getHtml() {
        return this._html;
    }

    getTitle() {
        return this._title;
    }

    getDescription() {
        return this._description;
    }

    getCard() {
        return this._card;
    }

    getLogo() {
        return this._logo;
    }

    getSite() {
        return this._site;
    }

    getPlatforms() {
        return this._platforms;
    }

    setPlatforms(platforms) {
        this._platforms = platforms;
    }

    setExternalContent(externalContent) {

        this._site = externalContent.meta.site;
        this._logo = externalContent.logo;
        this._title = externalContent.meta.title;
        this._description = externalContent.meta.description;
        this._card = externalContent.html_card;
        this._html = externalContent.html;
        this._url = externalContent.url;
        this._duration = externalContent.meta.duration;
        this._media = externalContent.meta.media;
        this._rel = externalContent.rel;
        this._thumbnail = externalContent.thumbnail;

    }

    clearData() {

        this._platforms = null;
        this._site = "";
        this._logo = "";
        this._title = "";
        this._description = "";
        this._card = "";
        this._html = "";
        this._url = "";
        this._duration = null;
        this._media = "";
        this._rel = [];
        this._thumbnail = "";

    }

}